<template>
  <div class="doclib-file-list">
    <div class="index-header">
      <i class="iconfont icon-back" @click="backPrevPage"></i>
      <p><img :src="iconImage" />{{libraryInfo.name}}</p>
      <span></span>
    </div>
    <div class="file-list-header">
      <div class="file-left" @click="showThemeDialogFn(true)">
        <i class="iconfont icon-catalogue"></i>
        <span class="ellipsis">{{documentName}}</span>
      </div>
      <div class="file-right">
        <i class="iconfont icon-icon-nav" @click="goToSearchPage"></i>
        <i class="iconfont icon-tag" @click="showSelectTagDialogFn(true)"></i>
        <i class="iconfont icon-a-biaoqian1" @click="showSortDialogFn(true)"></i>
      </div>
    </div>
    <div class="file-list" @scroll="handleScroll" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" v-if="!noFiles">
      <template v-for="(file, fileIndex) in fileList">
        <file-card
          :card-data="file"
          :key="fileIndex"
          :permissionsData="permissionsData"
          @show-menu="showMenuListFn"
        ></file-card>
      </template>
    </div>
    <div class="no-files" v-else>
      <img src="https://p5.ssl.qhimg.com/t110b9a93019a820ae6cc60c7ca.png" alt="">
      <span>暂无文档数据</span>
    </div>
    <common-footer-dialog v-if="showDetailDialog" @close-dialog="closeDetailDialog">
      <template #default>
        <file-detail :card-data="cardData"></file-detail>
      </template>
    </common-footer-dialog>

    <common-footer-dialog v-show="showSortDialog" @close-dialog="showSortDialogFn(false)">
      <template #default>
        <sort-list @select-sort="selectSortFn" :sortType="sortField"></sort-list>
      </template>
    </common-footer-dialog>

    <common-footer-dialog v-show="showMenuList" @close-dialog="closeMenuListFn">
      <template #default>
        <menu-list
          :cardData="cardData"
          :permissionsData="permissionsData"
          @menu-click="menuClickFn"
        ></menu-list>
      </template>
    </common-footer-dialog>

    <common-page-dialog v-if="showSelectTagDialog">
      <template #default>
        <tag-list
          :activeTagList="activeTagIdList"
          @save-tag-active="saveTagActiveList"
          @close-tag-dialog-fn="showSelectTagDialogFn(false)"
        ></tag-list>
      </template>
    </common-page-dialog>

    <common-page-dialog v-show="showThemeDialog">
      <template #default>
        <theme-list
          :libraryInfo="libraryInfo"
          @select-theme="selectThemeFn"
          @close-theme-dialog="showThemeDialogFn(false)"
        ></theme-list>
      </template>
    </common-page-dialog>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { LIBRARY_INFO, SEARCH_FILES, LIBRARY_USER_PERMISSIONS } from '@/config/api'
import FileCard from './FileCard'
import FileDetail from './FileDetail'
import CommonFooterDialog from '../CommonFooterDialog'
import CommonPageDialog from '../CommonPageDialog'
import TagList from './TagList'
import ThemeList from './ThemeList'
import SortList from './SortList'
import MenuList from './MenuList'
import config from '@/config'
import { CommonMixin } from './commonMixin'
export default {
  name: 'DoclibFileList',
  data () {
    return {
      iconImage: '',
      libraryInfo: {},
      fileList: [],
      cardData: {},
      showDetailDialog: false,
      activeTagIdList: [],
      showSelectTagDialog: false,
      showSortDialog: false,
      showThemeDialog: false,
      permissionsData: {},
      showMenuList: false,
      fileListTotal: 50,
      fileListPage: 1,
      documentId: '0',
      documentName: '',
      sortField: 'created',
      tagsData: [],
      noFiles: false,
      startY: 0,
      freshLoading: false
    }
  },
  mixins: [CommonMixin],
  components: {
    FileCard,
    CommonFooterDialog,
    FileDetail,
    CommonPageDialog,
    TagList,
    SortList,
    ThemeList,
    MenuList
  },
  created () {
    this.initFileList()
  },
  mounted () {

  },
  computed: {
    title () {
      return config.enterprise_info.name
    }
  },
  methods: {
    initFileList () {
      const promiseList = [
        ajax({
          url: LIBRARY_INFO,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            library_id: this.$route.params.library_id
          }
        }),
        ajax({
          url: SEARCH_FILES,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            document_id: this.documentId,
            library_id: this.$route.params.library_id,
            page_number: this.fileListPage,
            page_size: 25,
            sort_field: this.sortField,
            tags: this.tagsData
          }
        }),
        ajax({
          url: LIBRARY_USER_PERMISSIONS,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            book_id: '',
            library_id: this.$route.params.library_id
          }
        })
      ]
      Promise.all(promiseList).then((values) => {
        if (values.every(item => item.success)) {
          this.libraryInfo = values[0].data
          this.documentName = values[0].data.name
          if (this.isImageUrl(values[0].data.pic_url) || this.isImageUrl(values[0].data.pic_file_id)) {
            this.iconImage = values[0].data.pic_url || values[0].data.pic_file_id
          } else {
            this.iconImage = require('../images/' + (values[0].data.pic_url || values[0].data.pic_file_id) + '.png')
          }
          this.fileList = values[1].data.books
          this.cardData = values[1].data.books[0]
          this.permissionsData = values[2].data
          this.fileListTotal = values[1].data.total
          this.noFiles = !values[1].data.total
        }
      })
    },
    showFileDetail (cardData) {
      this.cardData = cardData
      this.showDetailDialog = true
    },
    closeDetailDialog () {
      this.showDetailDialog = false
    },
    showSortDialogFn (show) {
      this.showSortDialog = show
    },
    saveTagActiveList (list, activeTagData) {
      this.activeTagIdList = list
      this.tagsData = activeTagData
      this.ininPage()
      this.showSelectTagDialog = false
      this.getFilterList()
    },
    showSelectTagDialogFn (show) {
      this.showSelectTagDialog = show
    },
    selectSortFn (type) {
      this.sortField = type
      this.ininPage()
      this.showSortDialogFn(false)
      this.getFilterList()
    },
    goToSearchPage () {
      this.appFn({
        action: 'route',
        data: `${window.location.origin}/h5/doclib/search?prev_link=${encodeURIComponent(window.location.href)}`
      }, () => {
        window.open(`${window.location.origin}/h5/doclib/search?prev_link=${encodeURIComponent(window.location.href)}`)
      })
    },
    showThemeDialogFn (show) {
      this.showThemeDialog = show
    },
    selectThemeFn (theme) {
      this.documentId = theme.id
      this.documentName = theme.name
      this.ininPage()
      this.showThemeDialogFn(false)
      this.getFilterList()
    },
    ininPage () {
      this.fileListPage = 1
      this.fileListTotal = 50
      this.fileList = []
    },
    showMenuListFn (cardData) {
      this.cardData = cardData
      this.showMenuList = true
    },
    closeMenuListFn () {
      this.showMenuList = false
    },
    menuClickFn (type, cardData) {
      this.closeMenuListFn()

      if (type === 'delete') {
        let fileList = this.fileList.filter(item => {
          return item.id !== cardData.id
        })

        this.fileList = fileList.concat([])
      } else if (type === 'info') {
        this.showFileDetail(cardData)
      }
    },
    backPrevPage () {
      this.appFn({
        action: 'route',
        data: `${window.location.origin}/h5/doclib/list`
      }, () => {
        this.$router.push({path: '/doclib/list'})
      })
    },
    handleScroll (e) {
      if (this.checkBottom(e) && this.fileList.length < this.fileListTotal) {
        this.fileListPage = this.fileListPage + 1
        this.getFilterList()
      }
    },
    checkBottom (e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      return scrollTop + clientHeight >= scrollHeight - 5 // 留5px的缓冲区
    },
    getFilterList () {
      ajax({
        url: SEARCH_FILES,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          document_id: this.documentId,
          library_id: this.$route.params.library_id,
          page_number: this.fileListPage,
          page_size: 25,
          sort_field: this.sortField,
          tags: this.tagsData
        }
      }).then(res => {
        if (res.success) {
          this.fileList = this.fileList.concat(res.data.books)
          this.cardData = res.data.books[0]
          this.fileListTotal = res.data.total
          this.noFiles = !res.data.total
        }
      })
    },
    touchStart (event) {
      this.startY = event.touches[0].clientY
    },
    touchMove (event) {
      const currentY = event.touches[0].clientY
      const distance = currentY - this.startY
      if (distance > 0) { // 向下滑动
        // 判断是否到达顶部
        const fileListScroll = document.getElementsByClassName('file-list')[0].scrollTop
        if (fileListScroll === 0 && distance > 30) {
          this.freshLoading = true
        }
      }
    },
    touchEnd (event) {
      const fileListScroll = document.getElementsByClassName('file-list')[0].scrollTop
      if (fileListScroll === 0 && this.freshLoading) {
        this.freshLoading = false
        this.ininPage()
        this.getFilterList()
      }
    },
    isImageUrl (url) {
      const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)/
      return regex.test(url)
    }
  }
}
</script>
<style lang="postcss" scoped>
.doclib-file-list {
  height: 100%;

  & i {
    position: relative;
    top: -1px;
  }

  & .index-header {
    width: 100%;
    display: flex;
    height: 44px;
    padding: 0px 20px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    &>p {
      display: flex;
      align-items: center;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      & img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
    }

    &>i {
      color: #1B2532;
      font-size: 16px;
      line-height: normal;
    }

    &>span {
      width: 20px;
    }
  }

  & .file-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 64px;
    padding: 20px 20px 12px;
    box-sizing: border-box;

    & i {
      width: 20px;
      height: 20px;
      font-size: 20px;
      line-height: normal;
      font-weight: 400;
      color: #626F84;
    }

    & .file-left {
      width: calc(100% - 160px);
      display: flex;
      align-items: center;
      flex-shrink: 0;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      & span {
        width: 100%;
        display: block;
        margin-left: 8px;
        line-height: normal;
      }
    }

    & .file-right {
      & i {
        margin-left: 20px;
      }
    }
  }

  & .file-list {
    height: calc(100% - 108px);
  }

  & .no-files {
    height: calc(100% - 108px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -60px;

    & img {
      width: 220px;
      flex-shrink: 0;
    }

    & span {
      color: #9EA7B8;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-top: 4px;
    }
  }
}
</style>
